module.exports = function (app) {
  "use strict";
  app.controller("pages.profile", [
    "$scope",
    "services",
    "sessionData",
    "$filter",
    "employerUtility",
    "brand",
    "coremetrics",
    "navigation",
    "$cookies",
    "modal",  
    "$timeout",
    function (
      $scope,
      services,
      sessionData,
      $filter,
      employerUtility,
      brand,
      coremetrics,
      navigation,
      $cookies,
      modal,
      $timeout        
    ) {
    
      var brands = ["hmbcbsde", "highmarkbcbsde", "de", "6004", "9011", "hmbcbswv", "ms", "highmarkbcbswv", "mbh:wv", "9009", "6003", "9010",
        "hmbcbs", "hbcbs", "highmarkbcbs", "6001", "9001", "hbs", "pbs", "hmbs", "6002", "highmarkblueshield", "wv","hmny","neny","wny","9017","9018","6014"];
       
       
        if (localStorage.getItem("togglecheck") === "true") {
          $scope.checkVal = true;
        } else {
          $scope.checkVal = false;
        }
      if (brands.indexOf(sessionData.employerInfo.brandName) > -1) {

        $scope.showToggle = true;
        var obj = {
          userId: sessionData.basicInfo.loginId,
          appName: "employer",
          deliveryChannel: "email",
          email: sessionData.employerInfo.planAdministrator.email
        };

        var postBody = {
          ltpaToken: $cookies.get("LtpaToken2"),
          accessToken: $cookies.get("Oauth_access_token"),
          brand: sessionData.employerInfo.planAdministrator.vendorName ? sessionData.employerInfo.planAdministrator.vendorName.toLowerCase() : "",
        };
        var generateCount = 0;
        var verificationFailed = false;
        var currentOtp;
        var correlationId;
        var validatePayload;
        var generateCount = 0;
        var updateObj;
        var modalEnrollScope = $scope.$new();
        var modalScope = $scope.$new();



        /*Toggle check code starts here*/
        $scope.toggleCheck = function () {
          if ($scope.checkVal === true && verificationFailed === false) {
            updateObj = {
              oamAccessToken: $cookies.get("Oauth_access_token"),
              hmhsmfaenrolled: "true",
              hmhsmfaphone: " ",
              hmhsmfaemail: sessionData.employerInfo.planAdministrator.email
            }


            $scope.checkVal = false;
            enrollMFA();

          } else if (verificationFailed === false) {
            updateObj = {
              oamAccessToken: $cookies.get("Oauth_access_token"),
              hmhsmfaenrolled: "false",
              hmhsmfaphone: " ",
              hmhsmfaemail: " "
            }

            disableModel()
            $scope.checkVal = true;
          }
        }

        function disableModel() {

          var modalInstance = modal.open({
            template: require("pages/disableMfa.html"),
            classes: "disable-model",
            controller: require("pages/disableMfa"),
            scope: modalScope
          });
              $("*").not(".hmhs-icon").on("click", function (e) {
              if (!$(e.target).is(".icon-caret-down,.hmhs-icon,.disable-model .ng-binding,.primary-header .ng-binding,.tooltipClose .icon-x")) {
                e.stopPropagation();
              }
            });
        }
        modalScope.disableCancel = function () {
          modalScope.closeModal();
          setOldStatus(false)
        }
        modalScope.disableMfa = function () {
          modalScope.closeModal();
          fireBaseTokenCall(false)
        }

        //  $scope.fireBaseTokenCall = function (retainStatus) {
        /*Firebase token starts here*/
        function fireBaseTokenCall(retainStatus) {

          services.eprsvc
            .fireBaseToken()
            .getTempToken(postBody, $cookies.get("Oauth_access_token"))
            .then(function (response) {
              if (response) {
                services.eprsvc
                  .fireBaseToken()
                  .getFirebaseToken(response.data)
                  .then(function (fireToken) {

                    //update user details
                    if (fireToken.data.idToken) {
                      services.eprsvc
                        .fireBaseToken()
                        .updateUser(updateObj, fireToken.data.idToken)
                        .then(function (finalData) {
                          if (finalData && finalData.data.status === "true") {
                            // Add challege Info
                            services.eprsvc
                              .challengeDisplayInfo()
                              .enrollCheck(sessionData.basicInfo.loginId)
                              .then(function (enrollData) {
                                var data = enrollData.data;
                                if (
                                  data &&
                                  data.challengeInfoList &&
                                  data.challengeInfoList.length > 0) {
                                  localStorage.setItem("togglecheck", "false");
                                } else {
                                  localStorage.setItem("togglecheck", "true");

                                }
                              }, function (error) {
                                setOldStatus(retainStatus)
                              });
                          }
                        },
                          function (error) {
                            setOldStatus(retainStatus)
                          });
                    }

                  },
                    function (error) {
                      setOldStatus(retainStatus)
                    });

              }
            },
              function (error) {
                setOldStatus(retainStatus)
              });
        }



        function enrollMFA() {

          modal.open({
            template: require("pages/multifactorLogin.html"),
            classes: "selected-groups-modal multifactor-large-modal",
            scope: modalEnrollScope
          });

          $("*").not(".icon-caret-down").on("click", function (e) {
            if (!$(e.target).is(".icon-caret-down,.hmhs-icon,.multifactor-info-modal .ng-binding,.primary-header .ng-binding,.epr-find-employee .secondary-button-1,.tooltipClose .icon-x")) {
              e.stopPropagation();
            }
          });

          modalEnrollScope.title = "For Your Protection";
          modalEnrollScope.emailId = sessionData.employerInfo.planAdministrator.email;
          modalEnrollScope.enableDefault = true;
          modalEnrollScope.enableButton = true;
          modalEnrollScope.enableNo = false;
          modalEnrollScope.enableYes = false;
          modalEnrollScope.btnValue = "Enable";
          resetAll();
        }


        modalEnrollScope.enable = function () {

          if (modalEnrollScope.btnValue == "Enable") {
            createOtp();
            modalEnrollScope.title = "Verify Passcode";
            modalEnrollScope.enableYes = true;
            modalEnrollScope.enableDefault = false;
            modalEnrollScope.btnValue = "Submit";
          } else if (modalEnrollScope.btnValue == "Close") {
            modalEnrollScope.closeModal();
            setOldStatus(true)
          } else if (modalEnrollScope.btnValue == "Submit") {
            var verificationSec = angular.element(
              document.getElementById("verificationVal")
            );
            modalEnrollScope.textbox = verificationSec.val();
            if (modalEnrollScope.textbox === "") {
              modalEnrollScope.submitError = true;
              modalEnrollScope.IsHidden = true;
              modalEnrollScope.errorFlag = true;
              generateCount++;
              if (generateCount === 3) {
                generateSec()
              }
            } else {
              validatePayload = {
                userId: sessionData.basicInfo.loginId,
                appName: "test",
                correlationId: correlationId,
                otpCode: modalEnrollScope.textbox,
              };
              services.eprsvc
                .validateOtp()
                .validatePin(validatePayload, $cookies.get("Oauth_access_token"))
                .then(function (response) {
                  modalEnrollScope.closeModal();
                  fireBaseTokenCall(true)
                },
                  function (error) {
                    modalEnrollScope.submitError = true;
                    modalEnrollScope.IsHidden = true;
                    modalEnrollScope.errorFlag = true;
                    generateCount++;
                    if (generateCount === 3) {
                      generateSec();
                    }
                  });
            }
          }
        }





        function resetAll() {
          modalEnrollScope.enableDefault = true;
          modalEnrollScope.enableButton = true;
          modalEnrollScope.enableYes = false;
          modalEnrollScope.notCommonhelpYes = false;
          modalEnrollScope.helpYes = false;
          modalEnrollScope.generateYes = false;
          modalEnrollScope.codeError = false;
          modalEnrollScope.errorFlag = false;
        }

        function generateSec() {
          generateCount = 0;
          modalEnrollScope.submitError = false;
          modalEnrollScope.IsHidden = false;
          modalEnrollScope.errorFlag = false;
          modalEnrollScope.enableYes = false;
          modalEnrollScope.enableButton = false;
          modalEnrollScope.codeError = true;
          modalEnrollScope.generateYes = true;
          modalEnrollScope.newCodeVal = "Generate New Verification Code";
          modalEnrollScope.cancelBtnValue = "Cancel my MFA Enrollment";
          modalEnrollScope.helpYes = true;
          modalEnrollScope.notCommonhelpYes = false;
        }


        function createOtp() {
          services.eprsvc
            .createOtp()
            .generateOtp(obj, $cookies.get("Oauth_access_token"))
            .then(function (response) {
              currentOtp = response.data.minorCode;
              correlationId = response.data.correlationId;
              generateCount = 0;
            });
        }
        modalEnrollScope.noThankYou = function () {

          modalEnrollScope.enableNo = true;
          modalEnrollScope.enableDefault = false;
          modalEnrollScope.btnValue = "Close";
        }

        modalEnrollScope.needHelp = function () {

          modalEnrollScope.title = "Multi-Factor Authentication (MFA) Support";
          modalEnrollScope.helpYes = true;
          modalEnrollScope.notCommonhelpYes = true;
          modalEnrollScope.enableYes = false;
          modalEnrollScope.enableButton = false;
          modalEnrollScope.submitError = false;
          modalEnrollScope.cancelBtnValue = "Cancel my MFA Enrollment";
        }

        modalEnrollScope.cancelPopup = function () {
          modalEnrollScope.closeModal();
          setOldStatus(true);
        }

        modalEnrollScope.newCode = function () {

          modalEnrollScope.enableYes = true;
          modalEnrollScope.enableButton = true;
          modalEnrollScope.btnValue = "Submit";
          modalEnrollScope.codeError = false;
          modalEnrollScope.generateYes = false;
          modalEnrollScope.helpYes = false;
          createOtp();
        }


        function setOldStatus(retainValue) {         
          if (retainValue === true) {
            $scope.checkVal = true;
          } else {
            $scope.checkVal = false;
          }
          verificationFailed = true;
          $timeout(function () {
            var autoClick = angular.element(
              document.getElementById("toggleButton")
            );
            autoClick.click();
            verificationFailed = false;
          }, 100);

        }
      }
      else {
        $scope.showToggle = false;
      }
//MFA section Ends 

          //SSO PNC changes starts
            if(sessionData && sessionData.employerInfo.ssoClient)
            {
              $scope.ssoClient = sessionData.employerInfo.ssoClient;
            }else
            {
              $scope.ssoClient = false;
            }
            //SSO PNC changes ends
            console.log(sessionData);
      $scope.showHeadline = true;
      $scope.isMcu =
        sessionData.basicInfo.role.toLowerCase().indexOf("mcu_admin") >= 0;
      var clientSelected = localStorage.getItem("clientSelected");
      if ($scope.isMcu && !clientSelected) {
        //sessionData.isClientselection = false;
        $scope.showHeadline = false;
        if (!clientSelected) {
          if (navigation.data.headerTabs.length) {
            navigation.data.headerTabs = [];
          }
          navigation.setFilter(
            "clientSelection",
            function (item) {
              return false;
            },
            {
              temp: true,
            }
          );
          navigation.addTempFilterToModules(
            ["socialLinksHMHS", "footerLinks", "footerTabsThree", "headerTabs"],
            "clientSelection"
          );
          //navigation.addTempFilterToModules(["logo", "footerLogo"], "clientSelectionLogos");

          navigation.update();
        }
        if (
          sessionData.employerInfo &&
          sessionData.employerInfo.planAdministrator &&
          sessionData.employerInfo.planAdministrator.company
        ) {
          delete sessionData.employerInfo.planAdministrator.company;
        }
        $scope.employer = sessionData.employerInfo.planAdministrator;
        $scope.sidebar = {
          breadCrumb: {
            primary: {
              title:
                "Profile for " +
                $filter("capitalize")($scope.employer.firstName) +
                " " +
                $filter("capitalize")($scope.employer.lastName),
            },
          },
        };
      } else {
        $scope.showHeadline = true;
        if (navigation.data.breadCrumbHome.length) {
          navigation.data.breadCrumbHome = [];
        }
        var paEntitlements = sessionData.entitlements,
          groupAccess =
            sessionData.employerInfo.planAdministratorEntitlements
              .groupLevelEntitlements;

        var siteAccessPermissions = [
          {
            label: "Employer Client/Groups",
            brands: ["6009", "9017", "9018"],
            entitlement: paEntitlements.employer.clientsOrGroups,
          },
          {
            label: "Enrollment Reports",
            brands: [
              "9001",
              "9002",
              "9003",
              "9009",
              "9010",
              "6002",
              "6011",
              "9011",
              "9012",
              "9004",
              "9005",
              "9006",
              "9007",
              "9008",
              "9015",
              "6009",
              "9016",
              "9017",
              "9018",
            ],
            entitlement: paEntitlements.reports.enrollment,
          },

          {
            label: "Census Report",
            brands: ["6010", "6011"],
            entitlement: paEntitlements.reports.CensusReports,
          },
          {
            label: "ID Theft protection",
            brands: [
              "9001",
              "9002",
              "6002",
              "9003",
              "9004",
              "9005",
              "9006",
              "9007",
              "6009",
              "9008",
              "9009",
              "9010",
              "9011",
              "9012",
              "9015",
              "9016",
            ],
            entitlement: paEntitlements.idTheft,
          },
          {
            label: "Reports",
            brands: [
              "9001",
              "9002",
              "9009",
              "9010",
              "6002",
              "9011",
              "9012",
              "9003",
              "9004",
              "9005",
              "9006",
              "9007",
              "9008",
              "9015",
              "9016",
            ],
            entitlement: paEntitlements.reports.atHand,
          },
          {
            label: "Claims",
            brands: [
              "9001",
              "9002",
              "9009",
              "9010",
              "6002",
              "9011",
              "9012",
              "9003",
              "9004",
              "9005",
              "9006",
              "9007",
              "9008",
              "6011",
              "6012",
              "9015",
              "9016",
              "9017",
              "9018",
            ],
            entitlement: paEntitlements.claims,
          },
          {
            label: "Bills",
            brands: [],
            entitlement: paEntitlements.ebill,
          },
          {
            label: paEntitlements.clientQualifiers.ucdDental ? "Dental" : null,
            brands: [],
            entitlement: paEntitlements.clientQualifiers.ucdDental,
          },
          {
            label: "Super User Role",
            brands: [
              "9001",
              "9002",
              "9003",
              "9009",
              "9010",
              "6002",
              "9011",
              "9012",
              "9004",
              "9005",
              "9006",
              "9007",
              "9008",
              "9015",
              "9016",
              "9017",
              "9018",
            ],
            entitlement: paEntitlements.superUserRole,
          },
          {
            label: "All Groups - Enrollment",
            brands: [
              "9001",
              "9002",
              "9003",
              "9009",
              "9010",
              "6002",
              "9011",
              "9012",
              "9004",
              "9005",
              "9006",
              "9007",
              "9008",
              "6011",
              "6012",
              "9015",
              "9016",
              "9017",
              "9018",
            ],
            entitlement: paEntitlements.allGroups.enrollment,
          },
          {
            label: "All Groups - Spending Accounts",
            brands: [
              "9001",
              "9002",
              "9003",
              "9009",
              "9010",
              "6002",
              "9011",
              "9012",
              "9004",
              "9005",
              "9006",
              "9007",
              "9008",
              "9015",
              "9016",
              "9017",
              "9018",
            ],
            entitlement: paEntitlements.allGroups.spendingAccount,
          },
          {
            label: "Research Only Role",
            brands: [
              "9001",
              "9002",
              "9003",
              "9009",
              "9010",
              "6002",
              "9011",
              "9012",
              "9004",
              "9005",
              "9006",
              "9007",
              "9008",
              "9015",
              "9016",
              "9017",
              "9018",
            ],
            entitlement: paEntitlements.researchOnlyRole,
          },
          {
            label: "Wellness Report",
            brands: ["6011"],
            entitlement: paEntitlements.wellnessReport,
          },
          {
            label: "Mede Analytics",
            brands: [
              "9001",
              "9002",
              "9003",
              "9009",
              "9010",
              "6002",
              "9011",
              "9012",
              "9004",
              "9005",
              "9006",
              "9007",
              "9008",
              "9015",
              "9016",
              "9017",
              "9018",
              "6011",
            ],
            entitlement: paEntitlements.reports.medeAnalytics,
          },
        ];
        var brandFilter = function (action, brandName) {
          if (!action.brands.length && action.label !== null) {
            return true;
          }
          // if ($scope.isMcu && action.label == "Mede Analytics") {
          //   return false;
          // }
          brandName = brandName || "";
          return action.brands.some(function (b) {
            return (
              b.toLowerCase() === brandName.toLowerCase() &&
              action.entitlement !== undefined
            );
          });
        };

        $scope.profileCoremetrics = function () {
          coremetrics.startConversion(
            "EMPLOYERS:PROFILE:CHANGE PASSWORD",
            "EMPLOYERS:PROFILE:CHANGE"
          );
          coremetrics.pageviewTag(
            "EMPLOYERS:HOME PAGE:PROFILE",
            "EMPLOYERS:HOME PAGE"
          );
        };
        $scope.sessionData = sessionData;
        $scope.employer = sessionData.employerInfo.planAdministrator;
        $scope.empAccessArray = siteAccessPermissions.filter(function (action) {
          return brandFilter(action, sessionData.employerInfo.brandName);
          //if(action.label != undefined){return action};
        });

        $scope.groupTable = {};

        $scope.sidebar = {
          breadCrumb: {
            primary: {
              title:
                sessionData.employerInfo.planAdministrator.displayLoginId.indexOf(
                  "VIEW"
                ) >= 0
                  ? "Profile for " +
                  $scope.employer.firstName +
                  " " +
                  $scope.employer.lastName
                  : "Profile for " +
                  $filter("capitalize")($scope.employer.firstName) +
                  " " +
                  $filter("capitalize")($scope.employer.lastName),
            },
          },
        };

        $scope.isIBC = brand.current.sharedBrandCode.toLowerCase() === "ibccr";
        $scope.isAH = brand.current.sharedBrandCode.toLowerCase() === "ibcah";
        $scope.isProducer = Boolean($cookies.get("multiClientID"));
        $scope.isViewOnlyUser =
          sessionData.employerInfo.planAdministrator.displayLoginId.indexOf(
            "VIEW"
          ) >= 0;

        $scope.toolTipContent =
          "This displays the entitlements and access you have on the portal.";

        $scope.incorrectInfoWarning =
          $scope.isIBC || $scope.isAH
            ? "If this information is incorrect, please contact your Broker or Sales Representative"
            : "If this information is incorrect, contact your Client Manager";

        $scope.groupTableObj = {
          orderBy: "groupNumber",
          reverse: true,

          titles: [
            {
              name: "Group Number",
              dataKey: "groupNumber",
            },
            {
              name: "Employee Data",
              dataKey: "employeeData",
            },
          ],

          pagination: {
            itemsPerPage: 10,
            page: 1,
          },

          groupAccessArray: [],
        };

        if (!$scope.isMcu) {
          var spedTitle = {
            name: "Spending Account",
            dataKey: "spendingAccount",
          };
          $scope.groupTableObj.titles.push(spedTitle);
        }

        if (groupAccess) {
          for (var grp in groupAccess) {
            if (groupAccess.hasOwnProperty(grp)) {
              var group = {};
              var current = groupAccess[grp];

              group.groupNumber = grp;
              group.employeeData = current["Employee Data"] || "N/A";
              group.spendingAccount = current["Spending Account"] || "N/A";

              if (
                !(
                  group.employeeData === "N/A" &&
                  group.spendingAccount === "N/A"
                )
              ) {
                $scope.groupTableObj.groupAccessArray.push(group);
              }
            }
          }
        }
      }
    },
  ]);

  return [
    {
      state: "profile",
      url: "/profile",
      postPassword: true,

      views: {
        "body@": {
          template:
            bootstrap.templates["page-templates/hmhs/content-page.html"],
          controller: "pages.profile",
        },
        "content@profile": {
          templateUrl: "profile.employerTemplate.html/pages/profile/profile",
        },
      },
    },
  ];
};
